<ng-container *ngIf="vm$ | async as vm">
    <div class="fav-container" [class.selected]="vm.selected" (click)="toggleFavourite()">
        <fa-icon class="fav-heart" [icon]="['far', 'heart']"></fa-icon>
        <fa-icon class="fav-heart-solid" [icon]="['fas', 'heart']"></fa-icon>
    </div>
</ng-container>
